import { STAFF_SUPPORT_EMAIL } from "../../../../utils/userFacingError";

// Plain staff texts shared by Manage Ticket Sales and Manage Sponsorship
// Sales (wave 3). The page labels are checked in cmpNavbarPresentation.ts.

/** Apply Payment on an invoice with no balance owing. */
export const EVENT_INVOICE_NOTHING_TO_PAY_TEXT =
  "This invoice has no balance owing, so there is nothing to pay.";

/** Apply Payment on a sale whose invoice did not load. */
export const EVENT_INVOICE_NOT_FOUND_TEXT =
  "We could not find the invoice for this sale. Refresh the page and try again.";

/** A saved draft that the page cannot read. Drafts have Delete Invoice. */
export const EVENT_DRAFT_NOT_READ_TEXT =
  "We could not open this draft. Go to Invoices & Payments > Manage all Invoices & Payments, delete the draft, and create the invoice again.";

/** The sponsorship saved, but its invoice step did not finish. */
export const SPONSORSHIP_INVOICE_NOT_FINISHED_TEXT = `We could not create the invoice for this sponsorship. The sponsorship is saved. Select Finish invoice to try again. If it keeps happening, email ${STAFF_SUPPORT_EMAIL}.`;
